"use client";

import type { FC, ReactNode } from "react";
import { useId } from "react";
import { Button, DialogV2, DialogV2Body, DialogV2Content, DialogV2Description, DialogV2Footer, DialogV2Header, DialogV2Title } from "@akashnetwork/ui/components";
type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  keepLabel: string;
  discardLabel: string;
  onDiscard: () => void;
  children: ReactNode;
};
export const DiscardDeploymentDialog: FC<Props> = ({
  open,
  onOpenChange,
  title,
  description,
  keepLabel,
  discardLabel,
  onDiscard,
  children
}) => {
  const descriptionId = useId();
  return <DialogV2 open={open} onOpenChange={onOpenChange} data-sentry-element="DialogV2" data-sentry-component="DiscardDeploymentDialog" data-sentry-source-file="DiscardDeploymentDialog.tsx">
      <DialogV2Content className="max-w-md" aria-describedby={descriptionId} data-sentry-element="DialogV2Content" data-sentry-source-file="DiscardDeploymentDialog.tsx">
        <DialogV2Header data-sentry-element="DialogV2Header" data-sentry-source-file="DiscardDeploymentDialog.tsx">
          <DialogV2Title data-sentry-element="DialogV2Title" data-sentry-source-file="DiscardDeploymentDialog.tsx">{title}</DialogV2Title>
          <DialogV2Description id={descriptionId} data-sentry-element="DialogV2Description" data-sentry-source-file="DiscardDeploymentDialog.tsx">{description}</DialogV2Description>
        </DialogV2Header>
        <DialogV2Body className="flex flex-col gap-3" data-sentry-element="DialogV2Body" data-sentry-source-file="DiscardDeploymentDialog.tsx">{children}</DialogV2Body>
        <DialogV2Footer className="flex items-center justify-end gap-2" data-sentry-element="DialogV2Footer" data-sentry-source-file="DiscardDeploymentDialog.tsx">
          <Button type="button" variant="ghost" onClick={() => onOpenChange(false)} data-sentry-element="Button" data-sentry-source-file="DiscardDeploymentDialog.tsx">
            {keepLabel}
          </Button>
          <Button type="button" variant="destructive" onClick={onDiscard} data-sentry-element="Button" data-sentry-source-file="DiscardDeploymentDialog.tsx">
            {discardLabel}
          </Button>
        </DialogV2Footer>
      </DialogV2Content>
    </DialogV2>;
};